module.exports = __webpack_public_path__ + "static/media/video_low_spa.0330dfb2.mp4";